import AccordionHeader from "./AccordionHeader";
import PropTypes from "prop-types";
import React from "react";
import colors from "theme/config/colors";
import styled from "theme/libs/styled";
import withHeightAuto from "core-web/components/withHeightAuto";

const Wrapper = styled("div")`
    border-radius: 12px;
    transition: all ${({ theme }) => `${theme.transitions.primary}`};
`;

const InnerWrapper = styled("div")`
    overflow: hidden;
    transition: 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);
`;

const AnimationWrapper = withHeightAuto(InnerWrapper);

const Accordion = ({ active, label, children, handleClick, setActiveAccordion, value, ...props }) => {
    if (!children) {
        return null;
    }

    return (
        <Wrapper
            px={["16px", null, null, null, "24px"]}
            border={`1px solid ${active ? colors.black_70 : colors.neutral_100}`}
            {...props}
        >
            <AccordionHeader label={label} active={active} onclick={handleClick} />
            <AnimationWrapper height={active ? "auto" : 0}>{children}</AnimationWrapper>
        </Wrapper>
    );
};

Accordion.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node.isRequired,
    handleClick: PropTypes.func,
    label: PropTypes.string,
    setActiveAccordion: PropTypes.func,
    value: PropTypes.string,
};

Accordion.defaultProps = {
    active: false,
    handleClick: () => {},
    label: "",
    setActiveAccordion: () => {},
    value: null,
};

export default Accordion;
